import React, { Component } from 'react'
import utils from '../utils'
const { FE } = utils

export default class CopyRight extends Component {
  render(){
    return(
      <div className={FE.APP.isApp()?"copyright fn-hide":"copyright"}>
        <span>©2019  Autohome 汽车之家</span><a href="//m.autohome.com.cn/bug/">意见反馈</a>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/CopyRight.js